exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-breadcrumb.el-breadcrumb[data-v-b50ef614]{display:inline-block;margin-left:0.04167rem;font-size:0.07292rem;line-height:0.26042rem}.app-breadcrumb.el-breadcrumb .no-redirect[data-v-b50ef614]{color:#272727;cursor:text}\n", ""]);

// exports
